var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVideoPlaceholder300 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 300,
  height: 300,
  viewBox: "0 0 300 300",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 300,
  height: 300,
  fill: "#F2F2F2"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6786_20411)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M183.333 140V116.667C183.333 113 180.333 110 176.667 110H96.6667C93 110 90 113 90 116.667V183.333C90 187 93 190 96.6667 190H176.667C180.333 190 183.333 187 183.333 183.333V160L210 186.667V113.333L183.333 140Z",
  fill: "#D0D0D0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6786_20411"
}, /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 160,
  fill: "white",
  transform: "translate(70 70)"
})))));
export { SvgVideoPlaceholder300 as ReactComponent };
export default __webpack_public_path__ + "b4802fdb52b8c5d0c80e75838113222d.svg";